module.exports = __webpack_public_path__ + "static/img/WechatIMG251.5bd35c7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/center/WechatIMG251.gif
// module id = SFcU
// module chunks = 2